interface CappedSidebarNavItems<T> {
  hiddenItems: T[]
  visibleItems: T[]
}

export function capSidebarNavItems<T>({
  isActive,
  items,
  maxRows,
}: {
  isActive: (item: T) => boolean
  items: readonly T[]
  maxRows: number | undefined
}): CappedSidebarNavItems<T> {
  if (maxRows === undefined || items.length <= maxRows) {
    return { hiddenItems: [], visibleItems: [...items] }
  }

  const rowsBesideMoreMenu = Math.max(0, maxRows - 1)
  const visibleItems = items.slice(0, rowsBesideMoreMenu)
  const overflowItems = items.slice(rowsBesideMoreMenu)
  const activeOverflowItem = overflowItems.find(isActive)
  if (activeOverflowItem !== undefined && rowsBesideMoreMenu > 0) {
    visibleItems[visibleItems.length - 1] = activeOverflowItem
  }

  return {
    hiddenItems: items.filter((item) => !visibleItems.includes(item)),
    visibleItems,
  }
}
